import { gql } from "@apollo/client"

const USER_PREFERENCES_FIELDS = gql`
  fragment UserPreferencesFields on UserPreferences {
    hideCompletedSteps
    pinPrimaryNavigation
    language
  }
`

export { USER_PREFERENCES_FIELDS }
